<template>
    <div>
        <wx-header></wx-header>
        <cus-count :cje="total"></cus-count>
        <wx-left-top :orderData="allData.item"></wx-left-top>
        <wx-left-bottom :jgData="allData.jgData"></wx-left-bottom>
        <wx-right-top :listData="userData"></wx-right-top>
        <wx-right-middle></wx-right-middle>
        <wx-right-bottom :listData="newsData"></wx-right-bottom>
        <div class="middle">
            <div id="map" style="width: 900px; min-height: 800px"></div>
            <div class="scroll-box">
                <vue-seamless-scroll :data="actData" class="seamless-warp" :class-option="option">
                    <ul class="fk-table-content">
                        <li v-for="(item, i) in actData" :key="i">
                            <span class="titleFirst firstSpan" v-text="item.title"></span><span class="date secSpan">{{ $moment(item.created_at_ts * 1000).format('yy-MM-DD') }}</span>
                        </li>
                    </ul>
                </vue-seamless-scroll>
                <vue-seamless-scroll v-if="zjData.length" :data="zjData" class="seamless-warp" :class-option="option">
                    <ul class="fk-table-content">
                        <li v-for="(item, i) in zjData" :key="i">
                            <span class="title firstSpan" v-text="item.name"></span><span class="date secSpan">{{ item.area.name | filterCity }}</span
                            ><span class="date secSpan">{{ item.exp_type == 1 ? '法律' : item.exp_type == 2 ? '心理' : '健康' }}</span>
                        </li>
                    </ul>
                </vue-seamless-scroll>
            </div>
        </div>
    </div>
</template>

<script>
import cusCount from './turnup.vue';
import wxHeader from '@/components/header.vue';
import wxLeftTop from './leftTop.vue';
import wxLeftBottom from './leftBottom.vue';
import wxRightTop from './rightTop.vue';
import wxRightMiddle from './rightMiddle.vue';
import wxRightBottom from './rightBottom.vue';
import vueSeamlessScroll from 'vue-seamless-scroll';
import echarts from 'echarts';
import luoyang from '@/assets/map/luoyang.json';
// import moment from 'moment';
export default {
    props: {},
    data() {
        return {
            myChart: '',
            allData: {},
            total: 0,
            actData: '',
            zjData: [],
            userData: [],
            newsData: []
        };
    },
    computed: {
        option() {
            return {
                limitMoveNum: 3,
                step: 0.2
            };
        }
    },
    created() {},
    mounted() {
        this.myChart = echarts.init(document.getElementById('map'), null, {
            devicePixelRatio: 2
        });
        this.initMap(luoyang, '洛阳');
        this.getData();
        this.getAct();
        this.getzj();
        this.getUserData();
        this.getNewsData();
    },
    watch: {},
    methods: {
        getData() {
            this.$http.ajax({ method: 'get', url: 'users/stats/4103' }).then((res) => {
                this.allData.item = res.children.items.map((item, i) => {
                    return {
                        value: item.group_count,
                        name: item.group_str
                    };
                });
                this.allData.jgData = res.thinktank.items.map((item, i) => {
                    return {
                        value: item.type_count,
                        name: item.type_str
                    };
                });
                this.total = res.children.total;
            });
        },
        getAct() {
            this.$http.ajax({ method: 'get', url: 'activities', data: { per_page: 10000 } }).then((res) => {
                this.actData = res.data;
            });
        },
        getzj() {
            this.$http.ajax({ method: 'get', url: 'thinktanks', data: { per_page: 10000, type: 2 } }).then((res) => {
                this.zjData = res.data;
                this.filterData(JSON.stringify(res.data));
            });
        },
        getUserData() {
            this.$http.ajax({ url: 'users/stats/new/user' }).then((res) => {
                this.userData = res;
            });
        },
        getNewsData() {
            this.$http.ajax({ url: 'users/stats/new/content' }).then((res) => {
                this.newsData = res;
            });
        },
        filterData(d) {
            d = JSON.parse(d);
            for (let i = 0; i < d.length; i++) {
                for (let j = 0; j < d.length; j++) {
                    if (d[i].exp_type === d[j].exp_type) {
                        this.$set(this.zjFL[i], 'count', this.zjFL[i].count + 1);
                        // this.zjFL[i].count = this.zjFL[i].count + 1;
                    }
                }
            }
        },
        initMap(data, name) {
            console.log(luoyang);
            echarts.registerMap(name, data);
            var option = {
                tooltip: {
                    show: true,
                    formatter: function (params) {
                        return params.name;
                    }
                },
                // visualMap: {
                //     min: 500,
                //     max: 7000,
                //     left: 'left',
                //     top: 'bottom',
                //     text: ['高', '低'], // 文本，默认为数值文本
                //     calculable: true
                //     //color: ['blue', 'blue']
                // },
                grid: {
                    right: '0%',
                    bottom: '0%'
                },

                series: [
                    {
                        name: 'MAP',
                        type: 'map',
                        mapType: name,
                        selectedMode: 'false', //是否允许选中多个区域
                        aspectScale: 0.8,
                        layoutCenter: ['49%', '55%'], //地图位置
                        layoutSize: '80%',
                        zoom: 1, //当前视角的缩放比例
                        itemStyle: {
                            normal: {
                                areaColor: 'rgba(55,113,255,0.3)',
                                borderColor: '#00d1ff',
                                borderWidth: 1
                                // opacity: 1,
                            },
                            emphasis: {
                                areaColor: 'rgba(55,113,255,0.8)',
                                borderColor: '#00d1ff',
                                borderWidth: 1,
                                opacity: 1,
                                label: {
                                    show: false,
                                    color: '#fff'
                                }
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'center',
                                textShadowColor: '#000',
                                textShadowBlur: 5,
                                color: '#FFFFFF',
                                fontWeight: 'bold',
                                fontSize: 14
                            }
                        }
                    }
                ]
            };

            this.myChart.setOption(option);
            this.myChart.on('click', (params) => {
                var timeFn = null;

                console.log(params);

                clearTimeout(timeFn);
                //由于单击事件和双击事件冲突，故单击的响应事件延迟250毫秒执行
                timeFn = setTimeout(() => {
                    this.$router.push({ name: 'Detail', query: { flag: params.name } });
                    var name = params.name; //地区name
                    // var mapCode = provinces[name]; //地区的json数据

                    // console.log(mapCode);
                    console.log(name);
                    // debugger;
                }, 250);
            });
        }
    },
    filters: {
        filterCity(d) {
            console.log('test', d.split('洛阳市')[1]);
            if (d.split('洛阳市')[1] && d.split('洛阳市')[1].length > 1) {
                return d.split('洛阳市')[1].split('区')[0] + '区';
            }
            return d;
        }
    },
    components: {
        wxHeader,
        wxLeftTop,
        wxLeftBottom,
        wxRightTop,
        wxRightMiddle,
        wxRightBottom,
        vueSeamlessScroll,
        cusCount
    }
};
</script>
<style scoped lang="scss">
.middle {
    position: absolute;
    z-index: 0;
    // left: 50%;
    // transform: translateX(-50%);
    left: 550px;
    right: 550px;
    bottom: 10px;
    top: 120px;
    // left: 50%;
    // transform: translateX(-50%);
    .seamless-warp {
        overflow: hidden;
        height: 200px;
        width: 100%;
        &:nth-of-type(1) {
            width: 48%;
            li:nth-child(even) {
                background: rgba($color: #20456d, $alpha: 0.9);
            }
        }
        &:nth-of-type(2) {
            width: 48%;
            li:nth-child(odd) {
                background: rgba($color: #20456d, $alpha: 0.9);
            }
        }
    }
    .fk-table-content {
        color: #00c2ff;
        li {
            width: 100%;
            display: flex !important;
            display: block;
            font-size: 13px;
            justify-content: space-between;
            height: 40px;
            align-items: center;
            padding: 0 10px;
            span {
                display: inline-block;
                letter-spacing: 1px;
            }
        }
        .titleFirst {
            width: 60%;
            overflow: hidden;

            text-overflow: ellipsis;

            white-space: nowrap;
        }
        .firstSpan {
            // flex: 2;
            // width: 50%;
            margin-right: 20px;
        }
        .secSpan {
            // width: 20%;
            margin-right: 20px;
            text-align: left;
        }
    }
}
.scroll-box {
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
